export const CAPACITOR = 'capacitor';
